// ropston config

export const marketplaceAddress = "0x2e671196116C9D23C79511B730E86b3FFce8db29"
